import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import * as momentTz from 'moment-timezone';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { DEFAULT_TIMEZONE } from '../constants/widget-constants';
import { TimezoneDbModel } from '../db-models/timezone.model';

@Injectable({
  providedIn: 'root'
})
export class TimezoneService {

  private http = inject(HttpClient);

  private _localTimezone: string | null = null;
  set localTimezone(timezone: string) {
    this._localTimezone = timezone;
  }
  get localTimezone(): string {
    return this._localTimezone;
  }

  getTimezones(): Observable<{ success: boolean, data: TimezoneDbModel[] }> {
    return this.http.get<{ success: boolean, data: TimezoneDbModel[] }>(environment.apiUrl + 'timezones', {});
  }

  getLocalTimezone(): string {
    let tz: string | null = null;

    try {
      tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (e) {
      tz = null;
    }

    // If Intl fails or returns nonsense, fallback to moment.tz.guess()
    if (!tz || tz.startsWith("Etc/")) {
      tz = momentTz.tz.guess(true);
    }

    return tz || DEFAULT_TIMEZONE;
  }
}
